module.exports = __webpack_public_path__ + "static/media/vk.b03024c4.svg";